var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getRealTime } from "../../Utils";
var SlotSelection = function (props) {
    var executeAction = props.executeAction, slots = props.slots;
    var doAction = function (interval) {
        if (executeAction)
            executeAction(getRealTime(interval[0]), "Here is the slot details:: start:" +
                interval[0] +
                ", end:" +
                interval[1]);
    };
    return (_jsx("div", __assign({ 
        // className="chat__messages-group"
        style: {
            marginTop: "15px",
        } }, { children: _jsx("ul", __assign({ className: "chat__messages-list multi_choice-list slots-selection-list" }, { children: slots.map(function (slot, index) {
                return (_jsx("div", __assign({ className: "multi_choice-list-item-btn \n                  ".concat(executeAction ? "" : "disabled", "\n               "), onClick: function () { return doAction(slot); } }, { children: _jsx("span", __assign({ className: "actual" }, { children: getRealTime(slot[0]) })) })));
            }) })) })));
};
export default SlotSelection;
